import React, {Component} from 'react'
import { Link } from "react-router-dom"
import '../../assets/stylesheets/header.scss'
import NavItems from "./NavItems"
import Drawer from "./Drawer"
import {PhoneLink, yelpLink} from '../Shared/Links'
import MailChimp from '../Shared/Mailchimp'
import Social from '../Shared/Social'
import logo from "../../assets/images/villaggio-logo.png"



class Header extends Component {
  render() {
    // const vclass = `v${this.props.version}`
    return (
      // <div className={[classes.headerSec, classes[vclass], classes.longNav].join(' ')}>
      // <div className="">
      //   {this.props.version === 'topbar' || this.props.version === null ?
      //     (<InfoBar which="topbar" />)
      //     : ''
      //   }
      // </div>

      <div id="h-wrap">
        <div className="announce-bar">
          <div className="constant">
            <div className="abLink phone"><PhoneLink /></div>
            <div className="abLink toLink"><button className="linky" uk-toggle="target: #takeout">Order for Delivery</button></div>
            <div className="abLink yelp"><a href={yelpLink} target="_blank" rel="noreferrer" className="linky"><span>Make</span> Reservations</a></div>
          </div>
        </div>
        <div className="clearfix"></div>

        <header className="header">
          <div className="main-header">
            <div className="mh-wrap">
              <div className="col-md-3 logo-block">
                <Link to="/"><img src={logo} alt="Villaggio Grille logo" className="logo-img" /></Link>
              </div>

              <div className="col-md-9 mega-tab">
                <NavItems />
              </div>

              <div className="mobNav"><Drawer /></div>
            </div>
          </div>

          <div id="top-bar-wrapper" className="clearfix">
            <div className="inner-tbw">
              <div className="tb-col tbc1">
                <PhoneLink />
              </div>

              <div className="tb-col tbc2">
                <MailChimp />
              </div>

              <div className="tb-col tbc3">
                <Social where="header" showTrip={true} />
              </div>
            </div>
          </div>
        </header>
      </div>

    )
  }
}
export default Header